<template>
    <tbody v-if="ticket && event && canMeetMinimum">
        <tr>
            <td class="hide-cell">
                <i
                    class="fa fa-ticket ticketround"
                    :style="{ backgroundColor: event.phcolour }"
                    aria-hidden="true"
                ></i>
            </td>

            <td data-label="Ticket name" class="tickets">
                {{ ticket.details }}
            </td>

            <td
                data-label="Early Bird Cost"
                data-th="Early Bird Cost"
                v-if="hasEarlyBird"
            >
                <div
                    :style="
                        !earlyBirdValid
                            ? {
                                  'text-decoration': 'line-through',
                                  color: 'gray',
                              }
                            : {}
                    "
                >
                    {{ ticket.cost_a | currency('£') }}
                </div>
            </td>

            <td data-label="Cost" data-th="Cost" v-if="hasPaidTickets">
                <div
                    :style="
                        earlyBirdValid
                            ? {
                                  'text-decoration': 'line-through',
                                  color: 'gray',
                              }
                            : {}
                    "
                >
                    {{ ticket.cost_b | currency('£') }}
                </div>
            </td>

            <td data-label="Vat Amount" data-th="Vat Amount" v-if="vatable">
                {{ calcVatAmount(ticket, discountValid) | currency('£') }}
            </td>

            <td
                data-label="Total Remaining"
                v-if="vatable"
                data-th="Total Remaining"
            >
                {{ calcPricePlusVat(ticket, discountValid) | currency('£') }}
            </td>

            <td
                data-label="Tickets Remaining"
                data-th="Tickets Remaining"
                v-if="event.show_tickets_remaining"
            >
                <strong>{{ ticket.tickets_remaining }}</strong>
            </td>

            <td
                data-label="Ticket Date & Time"
                data-th="Ticket Date & Time"
                class="ticket-date-time"
            >
                <span v-html="ticketTimeAndDate"></span>
            </td>

            <td
                data-label="Number of tickets"
                v-if="ticket.tickets_remaining > 0"
            >
                <select
                    v-if="ticket.group_amount > 1"
                    :disabled="disabled"
                    class="form-control input-lg ticket-select"
                    style="width: 100px !important"
                    v-model="quantityTickets"
                    @change="setTicket(ticket)"
                >
                    <option
                        v-for="n in minTicketNumberRange()"
                        :selected="n == quantityTickets"
                        :value="n"
                    >
                        {{ displayTicketAmount(n, ticket.group_amount) }}
                    </option>
                </select>

                <select
                    v-if="ticket.group_amount == 1"
                    :disabled="disabled"
                    class="form-control input-lg ticket-select"
                    style="width: 100px !important"
                    v-model="quantityTickets"
                    @change="setTicket(ticket)"
                >
                    <option
                        v-for="n in minTicketNumberRange()"
                        :selected="n == quantityTickets"
                        :value="n"
                    >
                        {{ n }}
                    </option>
                </select>
            </td>

            <td
                data-label="SOLD OUT"
                class="textalignment"
                v-if="ticket.tickets_remaining == 0"
            >
                <span class="label label-soldout">Sold Out</span>
            </td>
        </tr>

        <child-ticket
            v-if="showChild && !event.show_add_attendees"
            v-for="(childTicket, idx) in ticket.child_tickets"
            :key="idx"
            :event="event"
            :ticket="childTicket"
            :disabled="disabled"
        ></child-ticket>
        <child-ticket-view-only
            v-if="showChild && event.show_add_attendees"
            v-for="(childTicket, idx) in ticket.child_tickets"
            :event="event"
            :key="idx"
            :ticket="childTicket"
        ></child-ticket-view-only>

        <!-- TODO only show menu if we add attendee details now -->
        <!--  <menu-items v-if="showChild && event.show_add_attendees" :ticket="ticket" :event="event"></menu-items>-->
    </tbody>
</template>

<script>
import EventBus from '@/events/event-bus.js';
import menuItems from './menu-items.vue';
import ticketMixins from './tickets-mixin.js';
import childTicketRowBasic from './child-ticket-row-basic.vue';
import childTicketViewOnly from './child-ticket-view-only.vue';
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
    props: ['event', 'ticket', 'disabled'],

    components: {
        menuItems: menuItems,
        childTicket: childTicketRowBasic,
        childTicketViewOnly: childTicketViewOnly,
    },

    data() {
        return {
            vatRate: window.vatRate,
            quantityTickets: 0,
            discountValid: false,
            editMode: this.$store.getters.getReadOnly,
            startTime: null,
            endTime: null,
        };
    },

    mixins: [ticketMixins],

    created() {
        if (this.event && this.event.datetime_eb) {
            this.discountValid = moment(this.event.datetime_eb).isAfter(
                new Date()
            );
        }

        if (!this.ticket.quantity_tickets) {
            this.ticket.quantity_tickets = 0;
        }

        this.quantityTickets = this.ticket.quantity_tickets;

        if (this.editMode) {
            this.ticket.tickets_remaining =
                this.ticket.tickets_remaining + this.ticket.quantity_tickets;
        }

        if (this.ticket.tickets_remaining == null) {
            this.ticket.tickets_remaining = this.ticket.ticket_no;
        }

        if (this.ticket.start_time) {
            var sdt = new Date(this.ticket.start_time);
            this.startTime = moment(sdt).format('DD/MM/YYYY - HH:mm');
        }

        if (this.ticket.end_time) {
            var edt = new Date(this.ticket.end_time);
            this.endTime = moment(edt).format('DD/MM/YYYY - HH:mm');
        }
    },

    computed: {
        ...mapGetters({
            hasPaidTickets: 'getChargeable',
        }),
        canMeetMinimum() {
            var min = this.ticket.min_allowed || 1;
            // Hide ticket if remaining tickets can't meet the minimum requirement
            return this.ticket.tickets_remaining >= min;
        },
        showChild() {
            return this.quantityTickets > 0;
        },

        // showOnlyForOne() {
        //   return this.quantityTickets == 1;
        // },

        ticketTimeAndDate() {
            if (this.startTime && this.endTime) {
                return `${this.startTime} <br/> ${this.endTime}`;
            } else if (this.startTime && !this.endTime) {
                return this.startTime;
            } else {
                return '';
            }
        },
    },

    methods: {
        displayTicketAmount(n, group_amount) {
            if (n == 0) {
                return n;
            } else {
                return n + ' x ' + group_amount;
            }
        },

        childTicketsRemaining(childTicket) {
            if (!childTicket.quantity_tickets) {
                childTicket.quantity_tickets = 0;
            }
            if (!childTicket.tickets_remaining) {
                return 0;
            } else {
                childTicket.tickets_remaining;
            }
        },

        getVatRate(ticket) {
            if (ticket.vat_rate) {
                this.vatRate = ticket.vat_rate.rate;
            }
            return this.vatRate;
        },

        calcVatAmount(ticket) {
            var vatRate = this.getVatRate(ticket) / 100;
            //TODO why is cost_a etc a string??
            if (this.discountValid) {
                return +ticket.cost_a * vatRate;
            } else {
                return +ticket.cost_b * vatRate;
            }
        },

        calcPricePlusVat(ticket) {
            if (this.discountValid) {
                return +ticket.cost_a + this.calcVatAmount(ticket);
            } else {
                return +ticket.cost_b + this.calcVatAmount(ticket);
            }
        },

        minTicketNumberRange() {
            var total = Math.min(
                this.ticket.tickets_remaining,
                this.ticket.max_allowed
            );

            var min = this.ticket.min_allowed || 1;
            var rangeArray = [];
            // Always include 0 so users can deselect the ticket
            rangeArray.push(0);
            for (var i = min; i < total + 1; i++) {
                rangeArray.push(i);
            }
            return rangeArray;
        },

        setTicket(ticket) {
            ticket.quantity_tickets = this.quantityTickets;
            EventBus.$emit('setTicket', ticket);
        },

        minTicketNumberRangeChild(ticket) {
            var total = Math.min(ticket.tickets_remaining, ticket.max_allowed);

            var min = ticket.min_allowed || 1;
            var rangeArray = [];
            // Always include 0 so users can deselect the ticket
            rangeArray.push(0);
            for (var i = min; i < total + 1; i++) {
                rangeArray.push(i);
            }
            return rangeArray;
        },
    },
};
</script>

<style scoped>
.ticketround {
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    border-radius: 20px;
    border-width: 10px;
    background: #ff9500;
    color: white;
    padding: 6px;
    font-size: 20px;
}

.sub {
    background-color: white !important;
    color: black;
}

.subticket {
}
</style>
